import { createAssignment as createAssignmentAPI, fetchUserByID } from "../api";

export const createAssignmentAction = async (assignmentObject, userID, setAssignment, setUser) => {
  const assignment = await createAssignmentAPI(assignmentObject, userID);
  setAssignment(assignment.data);
  setUser((await fetchUserByID(userID)).data)
  return assignment.data;
};
